/**
 * Columna de "última modificación" (ColumnUserLatestUpdated) de las tablas de
 * datos. Su `key` apunta al usuario (`lastUpdatedBy`) o al objeto
 * `internalControl`, que no sirven para ordenar; acá se la vuelve ordenable
 * por fecha de modificación (o de creación si nunca se modificó) sin tocar
 * cada tabla.
 */
export const LAST_MODIFIED_KEYS: ReadonlySet<string> = new Set(["lastUpdatedBy", "internalControl"]);

export function lastModifiedTimestamp(row: unknown): number | undefined {
  const r = row as {
    internalControl?: { updatedAt?: number; createdAt?: number };
    _creationTime?: number;
  } | null;
  return (
    r?.internalControl?.updatedAt ??
    r?.internalControl?.createdAt ??
    r?._creationTime
  );
}

export function withSortableLastModified<
  C extends {
    key: string;
    label: string;
    sortable?: boolean;
    sortValue?: (row: never) => unknown;
  },
>(columns: C[]): C[] {
  let changed = false;
  const out = columns.map((column) => {
    if (!LAST_MODIFIED_KEYS.has(column.key) || column.sortable !== undefined) {
      return column;
    }
    changed = true;
    return {
      ...column,
      sortable: true,
      sortValue: column.sortValue ?? lastModifiedTimestamp,
      // Sin título el encabezado no tiene dónde mostrar el orden.
      label: column.label || "Modificado",
    };
  });
  return changed ? out : columns;
}
